var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn_comm large",class:{
    disabled: _vm.option,
    fill: _vm.fill
  },attrs:{"type":"button","disabled":_vm.option},domProps:{"innerHTML":_vm._s(_vm.btnTxt)},on:{"click":function($event){return _vm.emitSend()}}})}
var staticRenderFns = []

export { render, staticRenderFns }